import { Component, Input, OnInit, inject } from '@angular/core';
import { News } from '@usheru-hff/shared/domain';
import { TRACKING_SERVICE, TrackingService } from '@usheru-hff/sdk/tracking';
import { ChannelService } from '@usheru-hff/sdk/channel';
import { TranslationsService } from '@usheru-hff/shared/utils-translation';
import { ENVIRONMENT } from '@environment';

@Component({
    selector: 'community-elements-ui-news-card',
    templateUrl: './ui-news-card-community.component.html',
    styleUrls: ['./ui-news-card-community.component.scss']
    // changeDetection: ChangeDetectionStrategy.OnPush,
    // encapsulation: ViewEncapsulation.None
    ,
    standalone: false
})
export class UiNewsCardComponent implements OnInit {
  private readonly channelService = inject(ChannelService);
  private readonly translationsService = inject(TranslationsService);
  private readonly trackingService = inject(TRACKING_SERVICE);
  private readonly env = inject(ENVIRONMENT);

  @Input() longtext = 80;
  @Input() news: News | undefined;
  date: string;

  placeholderImage = this.env.newsParams?.placeholderImg || this.channelService.getDefaultImg('landscape');

  ngOnInit(): void {
    this.date = new Date(this.news.publishDate).toLocaleDateString(this.translationsService?.currentLanguage()?.code, {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  }
  onRedirectToNews() {
    this.trackingService.trackEvent({
      action: 'ViewPost',
      properties: {
        category: 'News',
        label: this.news.title,
        new: this.news.title,
        idNew: this.news.id
      }
    });
  }
}
